var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-tag"},[_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.tag))]),(_vm.sub)?_c('span',{staticClass:"tag-sub"},[_vm._v(_vm._s(_vm.sub))]):_vm._e(),_c('div',{staticClass:"arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }